/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { documentsUpdateRaw } from "../../funcs/documentsUpdateRaw.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateDocumentRawRequest$inboundSchema,
};

export const tool$documentsUpdateRaw: ToolDefinition<typeof args> = {
  name: "documents-update-raw",
  description: `Update Document Raw`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await documentsUpdateRaw(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
